import { render, staticRenderFns } from "./SegmentIface.vue?vue&type=template&id=40619ff6&scoped=true&"
import script from "./SegmentIface.vue?vue&type=script&lang=js&"
export * from "./SegmentIface.vue?vue&type=script&lang=js&"
import style0 from "./SegmentIface.vue?vue&type=style&index=0&id=40619ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40619ff6",
  null
  
)

export default component.exports